import React, { useState } from "react";
import { FILE_URL } from "../../../../routes/ApiEndpoints";
import type { MediaPayload } from "../annotations/WhatsAppAnnotations";
import SpinnerWrapper from "components/common/atoms/SpinnerWrapper";
import {
  formatBytes,
  getExtensionFromMediaType,
  renderFileIcon,
} from "./helpers";

interface Props {
  mediaItems: MediaPayload[];
}

const MediaRenderer: React.FC<Props> = ({ mediaItems }) => {
  // Track loading state per image by index
  const [loadedImages, setLoadedImages] = useState<Record<number, boolean>>({});
  const handleImageLoad = (index: number) => {
    setLoadedImages((prev) => ({ ...prev, [index]: true }));
  };

  const renderMedia = (
    mediaItem: MediaPayload,
    fileUrl: string,
    index: number
  ) => {
    const mediaType = mediaItem.mediaType;
    switch (true) {
      case mediaType.startsWith("image/"):
        return (
          <>
            {!loadedImages[index] && (
              <div
                style={{
                  maxWidth: "10vw",
                  width: "10vw",
                  height: "14vw",
                  backgroundColor: "#eee",
                  borderRadius: "0.5vw",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <SpinnerWrapper isDiv={true} />
              </div>
            )}
            <img
              src={fileUrl}
              alt="media"
              className={`${
                loadedImages[index] ? "d-inline-block" : "d-none"
              } chat-media-image`}
              style={{
                maxWidth: "10vw",
                borderRadius: "0.5vw",
                cursor: "pointer",
                height: "14vw",
                width: "10vw",
                objectFit: "cover",
              }}
              onLoad={() => handleImageLoad(index)}
            />
            {mediaItem.mediaCaption && (
              <div style={{ width: "10vw", padding: "0.3vw" }}>
                {mediaItem.mediaCaption}
              </div>
            )}
          </>
        );

      case mediaType.startsWith("application/") ||
        mediaType.startsWith("text/"):
        const extension = getExtensionFromMediaType(mediaType);
        const IconComponent = renderFileIcon(mediaType);
        return (
          <div className="d-flex align-items-center">
            <span className="documentIcon">
              <IconComponent />
            </span>
            {mediaItem.mediaName && (
              <div className="d-flex flex-column">
                {mediaItem.mediaName}.{extension}
                <div className="d-block">
                  {formatBytes(mediaItem.mediaSize)}
                </div>
              </div>
            )}
          </div>
        );

      // Add more cases here for other media types if needed
      default:
        const ext = getExtensionFromMediaType(mediaType);
        const DefaultIcon = renderFileIcon("");
        return (
          <div className="d-flex align-items-center">
            <span className="documentIcon">
              <DefaultIcon />
            </span>
            {mediaItem.mediaName && (
              <>
                {mediaItem.mediaName}.{ext}
              </>
            )}
          </div>
        );
    }
  };

  return (
    <>
      {mediaItems.map((mediaItem, mediaIndex) => {
        const fileUrl = `${FILE_URL}/${mediaItem.mediaPath}`;
        return (
          <div
            key={mediaIndex}
            className={`media-message ${
              mediaItems.length > 1 && mediaIndex > 0 ? "marginTop1" : ""
            }`}
          >
            <a
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={`${
                mediaItem.mediaType.startsWith("image/") ? "img-max-width" : ""
              } media-link`}
            >
              {renderMedia(mediaItem, fileUrl, mediaIndex)}
            </a>
          </div>
        );
      })}
    </>
  );
};

export default MediaRenderer;
